/** @ignore */
/**
 * @description 解析url的query
 */
type ParseQuery = (query: string) => Record<string, string>;

export const parseQuery: ParseQuery = (query) => {
  const qString = query.split('?').pop();
  const queryArr = qString ? qString.split('&') : [];
  const params: Record<string, string> = {};
  for (let i = 0, n = queryArr.length; i < n; i += 1) {
    const arr = queryArr[i].split('=');
    if (arr.length > 0) {
      const key = decodeURIComponent(arr.shift() as string);
      const value = decodeURIComponent(arr.join('=')); // 参数如果带=，在这里加上去
      params[key] = value;
    }
  }
  return params;
};

/**
 * 解析url的query（此方法需指定key，用于兼容老版ios）
 * @param query url query
 * @param keys 指定要解析的key值数组
 */
type ParseQueryByKeys = (query: string, keys: string[]) => any;
export const parseQueryByKeys: ParseQueryByKeys = (query, keys) => {
  const params: Record<string, string> = {};
  const ikeys = keys || [];
  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys) {
    const reg = new RegExp(`${ikeys}=([^\\\\&]+)`);
    const match = query.match(reg);
    if (match) params[key] = decodeURIComponent(match[1]);
  }
  return params;
};

/**
 * 拼接query值
 * @param params 参数
 * @returns {string}
 */
type StringifyQuery = (params: Record<string, string>, unEncode?: boolean) => string;
export const stringifyQuery: StringifyQuery = (params, unEncode = false) =>
  Object.keys(params)
    .map((k) => (unEncode ? `${k}=${params[k]}` : `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`))
    .join('&');

// == 生成uuid
export function uuid(): string {
  const s: string[] = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i += 1) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  // eslint-disable-next-line no-bitwise
  s[19] = hexDigits.substr((Number(s[19]) & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  // eslint-disable-next-line no-multi-assign
  s[8] = s[13] = s[18] = s[23] = '-';

  return s.join('');
}

type RootDomain = 'qtfm.cn' | 'qingting.fm' | 'bjqtthirdbase.com' | 'bjqtforthbase.com' | 'bjqtfifthbase.com';
// == 简单获取根域，不支持com.cn这样的后缀
export function getEasyRootDomain(): RootDomain {
  const domainArr = document?.domain?.split('.') ?? [];
  const rootDomain = domainArr.slice(-2).join('.');
  return rootDomain as RootDomain;
}

// == 获取根域，不是普适性很高要求的不建议使用
export function getRootDomain(): string {
  if (!document?.domain) return '';
  const key = `mh_${Math.random()}`;
  const keyR = new RegExp(`(^|;)\\s*${key}=12345`);
  const expiredTime = new Date(0);
  const { domain } = document;
  const domainList = domain?.split('.') ?? [];

  const urlItems = [domainList.pop()];
  while (domainList.length) {
    urlItems.unshift(domainList.pop());
    const mainHost = urlItems.join('.');
    const cookie = `${key}=${12345};domain=.${mainHost}`;
    document.cookie = cookie;
    // 如果cookie存在，则说明域名合法
    if (keyR.test(document.cookie)) {
      document.cookie = `${cookie};expires=${expiredTime}`;
      return mainHost;
    }
  }
  return '';
}
